import { useEffect } from "react";
import { useMotionEnabled } from "./useMotionEnabled";

export const usePageReveals = route => {
  const enabled = useMotionEnabled();
  useEffect(() => {
    const root = document.getElementById("main-content");
    if (!root || !enabled) return;
    const seen = new WeakSet();
    const active = new Set();
    let frame = 0;
    const observer = new IntersectionObserver(entries => {
      let stagger = 0;
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        observer.unobserve(entry.target);
        // The SSR content is visible. Movement begins only once it actually enters view.
        const animation = entry.target.animate?.(
          [{ opacity: 0.15, transform: "translateY(32px)" }, { opacity: 1, transform: "none" }],
          { duration: 800, delay: Math.min(stagger++ * 90, 270), easing: "cubic-bezier(.22,.68,0,1)" }
        );
        if (animation) {
          active.add(animation);
          animation.onfinish = () => active.delete(animation);
        }
        entry.target.dataset.motionRevealed = "true";
      }
    }, { threshold: 0.15, rootMargin: "0px 0px -40px 0px" });
    const scan = () => {
      frame = 0;
      root.querySelectorAll('section h2, section h3, section figure, section > .max-w-7xl > p, [data-testid^="home-service-"], [data-testid^="home-region-"], [data-testid^="gallery-card-"]').forEach(element => {
        if (seen.has(element) || element.closest('[data-testid="hero-section"], form, [role="dialog"]')) return;
        if (element.parentElement.closest('[data-testid^="gallery-card-"], [data-testid^="home-service-"], [data-testid^="home-region-"]')) return;
        seen.add(element); observer.observe(element);
      });
    };
    const mutations = new MutationObserver(() => { if (!frame) frame = requestAnimationFrame(scan); });
    mutations.observe(root, { childList: true, subtree: true });
    scan();
    return () => {
      cancelAnimationFrame(frame); observer.disconnect(); mutations.disconnect();
      active.forEach(animation => animation.cancel());
    };
  }, [route, enabled]);
};